var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupOpen = function SvgGroupOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.25 19.75q-.729 0-1.24-.51-.51-.511-.51-1.24V6.558q0-.73.54-1.268.54-.54 1.268-.54h5.49l2 2h7.894q.672 0 1.158.434.486.433.563 1.066H11.186l-2-2H4.308a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v11.385q0 .105.053.173a.5.5 0 0 0 .14.116l2.332-7.789h16.658l-2.421 8.066a1.7 1.7 0 0 1-.642.902q-.47.34-1.043.34zm1.513-1.5H19.27l1.887-6.308H7.65z"
  })));
};
export default SvgGroupOpen;